const prefix = 'tasks/';

export const TASK_MANAGEMENT_LIST_TAG = `${prefix}`;
export const TASK_MANAGEMENT_RECORD_TAG = `${prefix}/id`;
export const TASK_MANAGEMENT_ATTACHMENTS_TAG = `${prefix}/attachments`;
export const TASK_MANAGEMENT_ACTIVITIES_TAG = `${prefix}/activities`;

export default TASK_MANAGEMENT_LIST_TAG;
